import {
  Component,
  HostBinding,
  Input,
  ElementRef,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'header-search',
  template: `
    <nz-input-group
      (click)="onSearch()"
      [nzAddOnBeforeIcon]="'anticon anticon-search'"
    >
      <input
        nz-input
        [(ngModel)]="q"
        (focus)="qFocus()"
        (blur)="qBlur()"
        placeholder="Search..."
      />
    </nz-input-group>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderSearchComponent implements AfterViewInit {
  q: string;

  qIpt: HTMLInputElement | any;

  @HostBinding('class.alain-default__search-focus') focus = false;
  @HostBinding('class.alain-default__search-toggled') searchToggled = false;

  @Input() set toggleChange(value: boolean) {
    if (typeof value === 'undefined') return;
    this.searchToggled = true;
    this.focus = true;
    setTimeout(() => this.qIpt.focus(), 300);
  }

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.qIpt = (this.el.nativeElement as HTMLElement).querySelector(
      '.ant-input'
    );
    this.qIpt.style.width = '0';
  }

  qFocus() {
    this.focus = true;
  }

  qBlur() {
    this.focus = false;
    this.searchToggled = false;
    this.qIpt.style.width = '0';
  }
  onSearch() {
    this.qIpt.style.width = '100%';
    this.qIpt.style.padding = '0';
    this.focus = true;
    this.searchToggled = true;
  }
}
